module.exports = __webpack_public_path__ + "img/logo.03d485c5.png";